// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1qaVC","balanceDisclaimer":"posDashboard_balanceDisclaimer__1nlUt"};